import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { features } from '../../data/content';
export function WhyItWorks() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-188" data-mp="cdgqlixawtgo">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-189" data-mp="ce8avxlg74rn">
        <SectionTag data-id="element-190" data-mp="8bbywpqey6wo">Por qué funciona</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-191" data-mp="8ak59kgdmj91">
          Por qué funciona
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-192" data-mp="hbia24yn2uso">
        {features.map((feature, i) => <m.div key={feature.title} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-navy/10 bg-cream p-6" data-id="element-193" data-mp="w3ipf89gjjo6" data-mpi={i}>
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy/10" data-id="element-194" data-mp="3revge99t04fu">
              <feature.icon size={20} className="text-navy" data-id="element-195" data-mp="7ivpk9pp8v6" />
            </div>
            <h3 className="mt-4 font-heading text-base font-semibold leading-snug text-navy" data-id="element-196" data-mp="5759pvxd6t51">{feature.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-197" data-mp="a5yk3fhcu40z">{feature.text}</p>
          </m.div>)}
      </div>
    </section>;
}